import React, { Component } from 'react';
import { StaticPage, TopbarContainer } from '..';
import { ContactForm } from '../../forms';
import { sendMail } from '../../util/api';
import { FormattedMessage } from '../../util/reactIntl';
import { ExternalLink } from '../../components/';
import Cookies from 'universal-cookie';

import css from './ContactPage.css';
import contactPerson from './Nils1.jpg';

import insta from '../../assets/icons/socialmedia/instagram-icon.png'; 
import fb from '../../assets/icons/socialmedia/facebook-icon.png'; 
import linkedIn from '../../assets/icons/socialmedia/linkedIn-icon.png';

export class ContactPage extends Component {
  constructor(props) {
    super(props);
    // Don't call this.setState() here!
    this.state = {
      subPage: 'third',
      contactForm: '1',
      submitInProgress: false,
      ready: false,
    };
    this.onMessageSubmit = this.onSubmit.bind(this);
    this.firstNextClick = this.firstNextClick.bind(this);
    this.onSubmit = this.onSubmit.bind(this);
  }

  componentDidMount() {
    if (window !== undefined) {
      if (window.location.hash) {
        if (window.location.hash === '#FAQ') {
          window.location = '/FAQ#FAQ';
          this.setState({ subPage: 'third' });
        } else if (window.location.hash === '#contact') {
          window.location = '/FAQ#contact';
          this.setState({ subPage: 'fourth' });
        }
      }
    }
  }

  onSubmit(values, form) {
    this.setState({
      submitInProgress: true,
    });
    const { name, email, message } = values;

    sendMail({
      to: process.env.REACT_APP_CONTACT_TO_MAIL,
      from: process.env.REACT_APP_CONTACT_FROM_MAIL,
      subject: `Nachricht von ${name}`,
      text: message,
      html: `<strong>${message}</strong>------${email}`,
      replyTo: email,
    }).then(response => {
      console.log(response);

      this.setState({
        submitInProgress: false,
        ready: true,
      });
    });
  }

  firstNextClick() {
    this.setState({ contactForm: '2' });
    this.setState({ subPage: 'fourth' });
    if (window !== undefined) window.scrollTo({ top: 0 });
  }

  render() {
    const cookies = new Cookies();  
    return (
      <StaticPage
        title={
          cookies.get('language') === 'en'
            ? 'socialbnb - contact us and get in touch'
            : 'socialbnb - Nimm Kontakt mit uns auf '
        }
        // react helmet let's us override meta tags based on last nested
        // check out page.js for implementation details- weasel
        description={
          cookies.get('language') === 'en'
            ? 'Any questions? Contact us. How do I book a holiday with socialbnb?'
            : 'Du hast noch Fragen? Nimm Kontakt mit uns auf! Wie buche ich einen Urlaub mit socialbnb?'
        }
        keywords={
          cookies.get('language') === 'en'
            ? 'online contact, help contact '
            : 'online Kontakt, Hilfe'
        }
        schema={{
          '@context': 'http://schema.org',
          '@type': 'ContactPage',
          name: 'socialbnb contact',
          url: 'https://socialbnb.org/contact',
          // contactPoint: [{
          //   telephone: '+49 1573 097 76 60',
          //   contactType: 'Customer Support',
          //   email: 'info@socialbnb.de'
          // }],
        }}
      >
        <div className={css.Wrapper}>
          {' '}
          <div id="topbar">
            <TopbarContainer />
          </div>
          <div className={css.contactFormWrapper}>
            <span className={css.line1}></span>
            <span className={css.line2}></span>
            <div className={css.contactPerson}>
              <img src={contactPerson} height="100%" alt=""></img>
            </div>

            <ContactForm
              onSubmit={this.onSubmit}
              contactForm={this.state.contactForm}
              firstNextClick={this.firstNextClick}
              submitInProgress={this.state.submitInProgress}
              ready={this.state.ready}
            />

            <div className={css.alternativeContact}>
              <span className={css.alternativeContactTitle}>
                <FormattedMessage id="contactForm.alternative" />
              </span>{' '}
              {/* <br /> */}
              <div className={css.linkContainer}>
                <a href="mailto:info@socialbnb.de">info@socialbnb.de</a>
                <a href="tel:+49 157 3097 76 60">+49 157 3097 76 60</a>
              </div>
              <div className={css.socialLinkContainer}>
                <ExternalLink href="https://www.instagram.com/socialbnb" target="_blank">
                  <img src={insta} className={css.socialmedia} alt="instagram"></img>
                </ExternalLink>

                <ExternalLink href="https://www.facebook.com/Socialbnb" target="_blank">
                  <img src={fb} className={css.socialmedia} alt="facebook"></img>
                </ExternalLink>

                <ExternalLink
                  href="https://www.linkedin.com/company/socialbnb/"
                  target="_blank"
                  alt="linkedin"
                  className={css.socialmedia}
                >
                  <img
                    src={linkedIn}
                    className={css.socialmedia}
                    target="_blank"
                    alt="facebook"
                  ></img>
                </ExternalLink>
              </div>
            </div>
          </div>
        </div>
      </StaticPage>
    );
  }
}

export default ContactPage;
